import {
  PreviewCard,
  createPreviewCardHandle,
  type PreviewCardProps,
} from "@circleco/compass/components/PreviewCard";
import type { ReactElement } from "react";
import { useMemo } from "react";

import { CardContentCompass } from "./CardContentCompass";

export interface ProfileHoverCardProps extends Pick<
  PreviewCardProps,
  "side" | "sideOffset" | "delay" | "closeDelay"
> {
  avatarURL?: string;
  children: ReactElement;
  communityMemberId: number | string;
  disabled?: boolean;
  headline?: string;
  messagingEnabled?: boolean;
  name?: string;
  publicUid?: string;
  side?: "left" | "right" | "bottom" | "top";
  sideOffset?: number;
  sqid?: string;
  userLastSeenAt?: string | null;
}

export const ProfileHoverCard = ({
  children,
  communityMemberId,
  publicUid,
  sqid,
  messagingEnabled,
  avatarURL,
  name = "",
  headline = "",
  disabled = false,
  side = "right",
  sideOffset = 5,
  delay = 300,
  closeDelay = 100,
  userLastSeenAt,
}: ProfileHoverCardProps) => {
  const handle = useMemo(() => createPreviewCardHandle(), []);

  if (disabled) return <span>{children}</span>;

  return (
    <PreviewCard
      trigger={children}
      side={side}
      sideOffset={sideOffset}
      delay={delay}
      closeDelay={closeDelay}
      handle={handle}
      className="p-5 min-w-80"
    >
      <CardContentCompass
        communityMemberId={communityMemberId}
        publicUid={publicUid}
        sqid={sqid}
        avatarURL={avatarURL}
        name={name}
        headline={headline}
        messagingEnabled={messagingEnabled}
        closeCard={() => handle.close()}
        userLastSeenAt={userLastSeenAt}
      />
    </PreviewCard>
  );
};
